export const BEGIN_API_CALL = 'BEGIN_API_CALL';
export const API_CALL_ERROR = 'API_CALL_ERROR';

const END_API_CALL_SUCCESS = 'END_API_CALL_SUCCESS';

export const beginApiCall = (entity: ApiCallsKey = 'NOT_SPECIFIED') => {
    return {
        type:
            entity !== 'NOT_SPECIFIED'
                ? `${BEGIN_API_CALL}_${entity}`
                : BEGIN_API_CALL,
    };
};

export const apiCallError = (
    error: unknown,
    entity: ApiCallsKey = 'NOT_SPECIFIED'
) => {
    error = error as Error;
    return {
        type:
            entity !== 'NOT_SPECIFIED'
                ? `${API_CALL_ERROR}_${entity}`
                : API_CALL_ERROR,
        payload: error,
    };
};

export const endApiCall = (entity: ApiCallsKey = 'NOT_SPECIFIED') => {
    return {
        type:
            entity !== 'NOT_SPECIFIED'
                ? `${entity}_${END_API_CALL_SUCCESS}`
                : END_API_CALL_SUCCESS,
    };
};

// thunks
export const setIsBusy = (isBusy: boolean, timeout?: number) => {
    return async (dispatch: any) => {
        if (isBusy) {
            dispatch(beginApiCall());
            if (timeout) {
                setTimeout(() => {
                    dispatch(endApiCall());
                }, timeout);
            }
        } else {
            dispatch(endApiCall());
        }
    };
};

//Props interface
export interface IsBusyProps {
    setIsBusy: (isBusy: boolean, timeout?: number) => Promise<void>;
}
